'use client';

import type { ReactNode } from 'react';
import { createContext, useState } from 'react';

export const LocalizedPageUrlContext = createContext<string | undefined>(undefined);
export const LocalizedPageUrlContextDispatchContext = createContext<
  React.Dispatch<React.SetStateAction<string | undefined>>
>(() => {});

export const LocalizedPageUrlProvider = ({ children }: { children: ReactNode }) => {
  const [url, setUrl] = useState<string>();

  return (
    <LocalizedPageUrlContext.Provider value={url}>
      <LocalizedPageUrlContextDispatchContext.Provider value={setUrl}>
        {children}
      </LocalizedPageUrlContextDispatchContext.Provider>
    </LocalizedPageUrlContext.Provider>
  );
};
